import React, { Component, Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import {
  DatePickerField,
  SelectField,
  CheckboxField,
} from 'Common/SemanticWrapper';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { REIMBURSEMENT_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ReimbursementReportFieldEnum as Fields } from 'Common/FieldEnum';

class ReimbursementReportFormContainer extends Component {
  reimbursementTypeOptions = [
    { value: 0, label: 'Federal Reimbursement' },
    { value: 1, label: 'State Reimbursement' },
  ];

  feedingOptions = [
    { value: 0, label: 'Breakfast / Lunch / Other' },
    { value: 1, label: 'Supper' },
  ];

  onChangeReimbursementType = reimbType => {
    if (reimbType !== 0) {
      this.props.change(Fields.FeedingType, 0);
    }
  };

  render() {
    const { reimbursementRates } = this.props;

    const rateOptions = reimbursementRates
      ? reimbursementRates.map((rate, i) => ({
          value: rate.Id,
          key: i,
          text: rate.Description,
        }))
      : [];

    return (
      <Fragment>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <ReduxFormButtonGroup
                label={'Reimbursement Type'}
                options={this.reimbursementTypeOptions}
                formName={REIMBURSEMENT_REPORT_FORM_NAME}
                value={this.props.formValues[Fields.ReimbursementType]}
                fieldName={Fields.ReimbursementType}
                onChange={this.onChangeReimbursementType}
              />
            </Grid.Column>
            <Grid.Column>
              <ReduxFormButtonGroup
                label={'Meal Type'}
                options={this.feedingOptions}
                formName={REIMBURSEMENT_REPORT_FORM_NAME}
                value={this.props.formValues[Fields.FeedingType]}
                fieldName={Fields.FeedingType}
                disabled={this.props.formValues[Fields.ReimbursementType] !== 0}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Field
                name={Fields.ReimbursementRateId}
                component={SelectField}
                type="text"
                label="Reimbursement Rates"
                options={rateOptions}
                className={'short'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Field
                label={'From Date'}
                name={Fields.FromDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                label={'To Date'}
                name={Fields.ToDate}
                component={DatePickerField}
                type="text"
                openToDate={moment()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                label={'Summary Only'}
                name={Fields.SummaryOnly}
                component={CheckboxField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }

  if (
    !moment(values[Fields.ToDate]).isSame(values[Fields.FromDate]) &&
    values[Fields.FromDate]
  ) {
    if (!moment(values[Fields.ToDate]).isAfter(values[Fields.FromDate])) {
      errors[Fields.ToDate] = 'To Date must be equal or after From Date.';
    }
  }

  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(REIMBURSEMENT_REPORT_FORM_NAME)(state),
    reimbursementRates:
      state.ReimbursementReportState.report.reimbursementRates,
    validate,
  };
};

const ReimbursementReportForm = reduxForm({
  form: REIMBURSEMENT_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(
      mapStateToProps,
      {}
    )(ReimbursementReportFormContainer)
  )
);

export { ReimbursementReportForm };



// WEBPACK FOOTER //
// ./src/pages/reimbursement/components/ReimbursementReportForm.js